import React from 'react';
import { useUser } from "@clerk/clerk-react";
import { SignIn, SignUp } from "@clerk/clerk-react";
import { Box, Typography, Paper, Tabs, Tab, CircularProgress } from "@mui/material";
import ClarityAnalytics from './clarity';
import { Waitlist } from "@clerk/clerk-react";

const AuthWrapper = ({ children }) => {
  const { isLoaded, isSignedIn } = useUser();

  if (!isLoaded) {
    return (
      <Box className="h-screen flex items-center justify-center">
        <CircularProgress />
      </Box>
    );
  }

  if (!isSignedIn) {
    return (
      <>
        <ClarityAnalytics />
        <Box className="h-screen flex flex-col lg:flex-row bg-gray-50">
          {/* Left side - Image and Text (7/12 width) */}
          <Box className="w-full lg:w-[58.33%] h-full bg-white p-4 lg:p-8 flex flex-col justify-center items-center">
            {/* Image container with responsive sizing */}
            <Box className="w-full flex justify-center mb-4 lg:mb-8">
              <img
                src="/sitemap.png"
                alt="Project Planning"
                className="hidden sm:block w-full max-w-[600px] lg:max-w-[80%] h-auto rounded-lg shadow-xl"
              />
            </Box>

            {/* Text content with better responsive typography */}
            <Typography
              variant="h4"
              className="mt-4 lg:mt-8 font-bold text-gray-800 text-center text-xl sm:text-2xl lg:text-3xl px-4"
            >
              Transform Your Ideas into Structured Projects
            </Typography>
            <Typography
              variant="h6"
              className="mt-2 lg:mt-4 text-gray-600 text-center max-w-2xl text-sm sm:text-base lg:text-lg px-4"
            >
              Our AI-powered platform helps you create comprehensive project
              plans, from requirements to data models, in minutes instead of
              weeks.
            </Typography>
          </Box>

          {/* Right side - Waitlist (5/12 width) */}
          <Box className="w-full lg:w-[41.67%] h-full bg-white flex items-center justify-center p-4 lg:p-8 overflow-y-auto">
            <Paper
              elevation={0}
              className="w-full max-w-[400px] p-4 sm:p-6 lg:p-8 bg-transparent"
            >
              <Typography
                variant="h4"
                className="mb-4 lg:mb-6 text-center font-bold text-gray-800 text-xl sm:text-2xl"
              >
                Join the Waitlist
              </Typography>
              <Waitlist signInUrl={false} />
            </Paper>
          </Box>
        </Box>
      </>
    );
  }

  return children;
};

export default AuthWrapper; 